import SearchEntry from './search-entry';
import "./search-entry.less";

export default SearchEntry;